<template>
  <l-layout :layout="['xs12']">
    <v-layout column>
      <v-layout>
        <v-flex>
          <v-btn color="primary" @click="register">注册</v-btn>
        </v-flex>
        <v-flex xs6>
          <p v-html="form.webSocketUrl">{{form.webSocketUrl}}</p>
        </v-flex>
      </v-layout>
      <v-latout>
        <v-flex xs6>
          <v-text-field label="url" v-model="form.url"></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-btn flat color="primary" @click="createWebSocket(form.url)">
            连接
          </v-btn>
        </v-flex>
      </v-latout>
      <v-layout>
        <v-flex xs6>
          <v-select :items="form.cloudItems" item-text="label" item-value="value" v-model="form.cloudMsg" label="云端下发"></v-select>
        </v-flex>
        <v-flex xs1>
          <v-btn flat color="primary" @click="cloudSendMsg">发送</v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-select :items="form.items" item-text="label" item-value="value" v-model="form.select" label="socket消息"></v-select>
        </v-flex>
        <v-flex xs1>
          <v-btn flat color="primary" @click="addSendMessage">发送</v-btn>
        </v-flex>
        <v-flex xs1>
          <v-btn flat color="primary" @click="form.sendMessageList = [];form.recvMessageList=[]">清空发送数据</v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6 class="mr-2">
          <v-card class="pa-2">
            <v-layout column>
              <p>发送指令</p>
              <v-flex xs12 v-for="(m,i) in form.sendMessageList" :key="i">
                <v-textarea rows="1" auto-grow v-model="m.content"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card class="pa-2">
            <v-layout column>
              <p>收到指令</p>
              <v-flex xs12 v-for="(m,i) in form.recvMessageList" :key="i">
                <v-textarea rows="1" auto-grow v-model="m.content"></v-textarea>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </l-layout>
</template>

<script>
let cloudMsgMap = {
  STATE: {
    'jsonrpc': '2.0',
    'method': 'STATE',
    'params': {
      'action': 'MEMORY , DISK , TEMPERATURE , HUMIDITY , SEMAPHORE , CAMERA_HEART_BEAT , CONTROLLER_HEART_BEAT , LED',
      'timestamp': '13838282818181',
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_SYNC: {
    'jsonrpc': '2.0',
    'method': 'DEVICESRV_SYNC',
    'params': {
      'timestamp': '13838282818181',
      'data': [
        {
          'operation': 'update',
          'plateNum': '',
          'passTimeConfs': [
            '13838282818181,13838282818181',
            '13838282818181,13838282818181'
          ],
          'key': '1000'
        }, {
          'operation': 'delete',
          'plateNum': '',
          'passTimeConfs': ['13838282818181,13838282818181',
            '13838282818181,13838282818181'],
          'key': '1001'
        }
      ]
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_SYS_UPGRADE: {
    'jsonrpc': '2.0',
    'method': ' DEVICESRV_SYS_UPGRADE',
    'params': {
      'url': '安装包url'
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_REBOOT: {
    'jsonrpc': '2.0',
    'method': 'DEVICESRV_REBOOT',
    'params': {
      'action': 'SELF_PROGRAM,SYSTEM,CAMERA,CONTROLLER,LED,G4',
      'timestamp': '13838282818181',
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_CONF: {
    'jsonrpc': '2.0',
    'method': 'DEVICESRV_CONF',
    'params': {
      'timestamp': '13838282818181',
      'confJson': ''
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_CTRLLIFT: {
    'jsonrpc': '2.0',
    'method': 'DEVICESRV_CTRLLIFT',
    'params': {
      'timestamp': '13838282818181',
      'ctrlId': '01'
    },
    'id': 'SAH249217A'
  },
  DEVICESRV_CURRPHOTO: {
    'jsonrpc': '2.0',
    'method': 'DEVICESRV_CURRPHOTO',
    'params': {
      'timestamp': '13838282818181',
      'ctrlId': '',
      'key': '作为图片标识'
    },
    'id': 'SAH249217A'
  },
  VEHICLE_DATA_RELEASE: {
    'method': ' VEHICLE_DATA_RELEASE ',
    'id': 'SAH249217A',
    'jsonrpc': '2.0',
    'params': {
      'timestamp': '13838282818181',
      'data': [{
        'objectCode': '川A11111',
        'passRuleIds': [{
          'edTime': '1564531200000',
          'ledPlusIn': '教工车辆|减速慢行|欢迎光临',
          'ledPlusOut': '教工车辆|减速慢行|一路平安',
          'passRuleId': '172400454024698868',
          'ruleType': 'object',
          'stTime': '1555839471242',
          'voiceIn': '教工车辆欢迎光临',
          'voiceOut': '教工车辆移路平安'
        }]
      }, {
        'objectCode': '川A22222',
        'passRuleIds': [{
          'edTime': '1564531200000',
          'ledPlusIn': '教工车辆|减速慢行|欢迎光临',
          'ledPlusOut': '教工车辆|减速慢行|一路平安',
          'passRuleId': '172400454024698868',
          'ruleType': 'object',
          'stTime': '1555839471242',
          'voiceIn': '教工车辆欢迎光临',
          'voiceOut': '教工车辆移路平安'
        }]
      }]
    }
  }
}
let cloudMsgToLabel = {
  STATE: '控制器属性监控',
  DEVICESRV_SYNC: '云端调用控制器服务',
  DEVICESRV_SYS_UPGRADE: '控制器系统远程升级',
  DEVICESRV_REBOOT: '重启设备',
  DEVICESRV_CONF: '修改预配值参数',
  DEVICESRV_CTRLLIFT: '控制道闸抬杆',
  DEVICESRV_CURRPHOTO: '控制摄像头-拍照上传【保留】',
  VEHICLE_DATA_RELEASE: '车辆数据下发'
}
let valueMap = {
  HEART_BEAT: {
    'jsonrpc': '2.0',
    'method': 'HEART_BEAT',
    'params': {
      'timestamp': '13838282818181',
      'parkDbVersion': '控制器数据库版本号',
      'sysVersion': '系统版本号',
      'state': {
        'memory': '内存',
        'disk': '磁盘存储',
        'temperature': '温度',
        'humidity': '湿度',
        'semaphore': '信号量'
      }
    },
    'id': 'SAH249217A'
  },
  BIZSRV_REPORT_OFFLINE: {
    'jsonrpc': '2.0',
    'method': 'BIZSRV_REPORT_ OFFLINE ',
    'params': {
      'timestamp': '13838282818181',
      'plateNum': '车牌',
      'ctrlPassTime': '同传输车牌图片时间一致',
      'ctrlId': '控制器编号',
      'passResult': '通行结果'
    },
    'id': 'SAH249217A'
  },
  BIZSRV_REPORT_ONLINE: {
    'jsonrpc': '2.0',
    'method': 'BIZSRV_REPORT_ ONLINE',
    'params': {
      'timestamp': '13838282818181',
      'plateNum': '车牌',
      'ctrlPassTime': '同传输车牌图片时间一致',
      'ctrlId': '控制器编号'
    },
    'id': 'SAH249217A'
  },
  BIZSRV_REPORT_ACK: {

    'jsonrpc': '2.0',
    'method': 'BIZSRV_REPORT_ACK',
    'params': {
      'timestamp': '13838282818181',
      'plateNum': '车牌',
      'ctrlPassTime': '同传输车牌图片时间一致',
      'ctrlId': '控制器编号'

    },
    'id': 'SAH249217A'
  },
  AUTH1: {'sn': '01'},
  AUTH2: {'sn': '02'}
}
let valueToLabel = {
  AUTH1: '控制器认证01',
  AUTH2: '控制器认证02',
  HEART_BEAT: '心跳数据包',
  BIZSRV_REPORT_OFFLINE: '控制器上报云端',
  BIZSRV_REPORT_ONLINE: '上报车牌识别结果【实时】',
  BIZSRV_REPORT_ACK: '上报车牌确认通行【后置摄像头确认上传】',
}
export default {
  name: 'listener',
  data () {
    return {
      form: {
        url: '',
        items: (function () {
          let items = []
          for (let v in valueToLabel) {
            items.push({value: v, label: valueToLabel[v]})
          }
          return items
        }()),
        cloudItems: (function () {
          let items = []
          for (let v in cloudMsgToLabel) {
            items.push({value: v, label: cloudMsgToLabel[v]})
          }
          return items
        }()),
        select: '',
        cloudMsg: '',
        sendMessageList: [],
        recvMessageList: [],
        webSocketUrl: ''
      },
      ws: null
    }
  },
  created () {
  },
  methods: {
    async register () {
      let res = await this.$store.dispatch('message/register')
      if (res.data.status + '' === '200') {
        this.form.webSocketUrl = res.data.data.websocketUrl.split('|').join('<br/>')
        console.log(this.form.webSocketUrl)
      }
    },
    async cloudSendMsg () {
      let res = await this.$store.dispatch('message/sendMsg', cloudMsgMap[this.form.cloudMsg])
    },
    createWebSocket (url) {
      this.ws = new WebSocket(url)
      this.ws.onopen = this.wsOpen()
      // this.ws.onclose = this.wsClose()
      this.ws.onmessage = this.wsMessage
    },
    wsOpen () {
      this.form.recvMessageList.push({content: 'connected'})
    },
    wsClose () {
      this.form.recvMessageList.push({content: 'connect closed'})
    },
    wsMessage (e) {
      console.log(e.data)
      this.form.recvMessageList.push({content: e.data})
    },
    addSendMessage () {
      let value = valueMap[this.form.select]
      let content = JSON.stringify(value, this.timestampGen)
      this.form.sendMessageList.push({content: content})
      this.ws.send(JSON.stringify(valueMap[this.form.select]))
    },
    timestampGen (key, value) {
      if (key === 'timestamp') {
        return (new Date()).getTime()
      }
      else {
        return value
      }
    }
  }
}
</script>

<style scoped>

</style>
